import React, { useContext } from 'react';

import { GridCard } from './grid-card';
import { GridCardContent } from './grid-card-content';
import { GridCardHeader } from './grid-card-header';
import { GridCardOfferFooter } from './grid-card-offer-footer';
import { GridCardProductFooter } from './grid-card-product-footer';

import { ViewportContext } from 'src/components/viewport';
import { BaseProps, Store } from '../../types';

export const ProductGridCard: React.FC<BaseProps & {
  smallerProductCardsMobileExperiment?: boolean;
}> = props => {
  const {
    brand,
    category,
    diffPercentage,
    highlightedName,
    imageSize,
    imageSrc,
    name,
    previousPriceText,
    price,
    properties,
    rank,
    rating,
    reviewsCount,
    selectable,
    selected,
    shouldLazyLoadImage,
    store,
    type = 'product',
    link,
    onClick,
    className,
    container,
    background,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
    onRankInCategoryClick,
  } = props;

  const cardProps = {
    link,
    className,
    container,
    background,
    selected,
    selectable,
    onClick,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
  };

  const headerProps = {
    brand,
    diffPercentage,
    imageSize,
    imageSrc,
    name,
    selectable,
    selected,
    shouldLazyLoadImage,
  };
  const contentProps = {
    category,
    diffPercentage,
    highlightedName,
    name,
    price,
    properties,
    rank,
    rating,
    reviewsCount,
    // Don't show shop logo in content for offers. Only pass currency for offers.
    store:
      type === 'product' ? store : ({ currency: store?.currency } as Store),
  };
  const footerProps = {
    type,
    rank,
    previousPriceText,
    category,
    store,
    link,
    onClick,
    onRankInCategoryClick,
  };

  // The card shouldn't be clickable for offers
  const isClickable = type === 'product';

  const { isMobile } = useContext(ViewportContext);

  return (
    <GridCard
      {...cardProps}
      isClickable={isClickable}
      FooterArea={FooterArea || <Footer {...footerProps} />}
      ActionArea={ActionArea}
      outlined={!props.smallerProductCardsMobileExperiment || !isMobile}
    >
      <GridCardHeader {...headerProps} />
      <GridCardContent
        {...contentProps}
        smallerProductCardsMobileExperiment={
          props.smallerProductCardsMobileExperiment
        }
      />
    </GridCard>
  );
};

type FooterProps = Pick<
  BaseProps,
  | 'type'
  | 'rank'
  | 'previousPriceText'
  | 'category'
  | 'store'
  | 'link'
  | 'onClick'
  | 'onRankInCategoryClick'
>;

const Footer: React.FC<FooterProps> = props => {
  const {
    type,
    rank,
    previousPriceText,
    category,
    store,
    link,
    onClick,
    onRankInCategoryClick,
  } = props;

  const productFooterProps = {
    rank,
    previousPriceText,
    category,
    store,
    link,
    onClick,
    onRankInCategoryClick,
  };
  const offerFooterProps = { store, link, onClick };

  if (type === 'product') {
    return <GridCardProductFooter {...productFooterProps} />;
  }

  if (type === 'offer') {
    return <GridCardOfferFooter {...offerFooterProps} />;
  }

  return null;
};
